webpackJsonp([0],{

/***/ "CCSn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca92acd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("pk5n");
function injectStyle (ssrContext) {
  __webpack_require__("tYPr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ca92acd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MY3S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"grid-component"}},[_c('div',{staticClass:"__image_container",style:(_vm.styles)},[_vm._t("default"),_vm._v(" "),(_vm.count > 0)?_c('div',{staticClass:"__image_body __quarter __image_count",on:{"click":function($event){_vm.passData()}}},[_c('p',[_vm._v(_vm._s(_vm.image_excess))])]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_read_more__ = __webpack_require__("uIjV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_photo_grid__ = __webpack_require__("aF89");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_read_more__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_photo_grid__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Tnj0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"photo-grid"}},[_vm._m(0),_vm._v(" "),_c('photo-grid',{attrs:{"box-height":'200px',"box-width":'30%',"excess-text":'+ {{count}}'},on:{"clickExcess":_vm.triggerClick}},_vm._l((_vm.image),function(imahe){return _c('img',{attrs:{"src":imahe.url}})})),_vm._v(" "),_c('photo-grid',{attrs:{"box-height":'200px',"box-width":'500px',"boxBorder":20,"excess-text":'+ {{count}}'},on:{"clickExcess":_vm.triggerClick}},_vm._l((_vm.images2),function(imahe){return _c('img',{attrs:{"src":imahe.url}})})),_vm._v(" "),_c('photo-grid',{attrs:{"box-height":'200px',"box-width":'40%',"excess-text":'+ {{count}}'},on:{"clickExcess":_vm.triggerClick}},_vm._l((_vm.images3),function(imahe){return _c('img',{attrs:{"src":imahe.url}})})),_vm._v(" "),_c('photo-grid',{attrs:{"box-height":'200px',"box-width":'20%',"excess-text":'+ {{count}}'},on:{"clickExcess":_vm.triggerClick}},_vm._l((_vm.images4),function(imahe){return _c('img',{attrs:{"src":imahe.url}})})),_vm._v(" "),_c('photo-grid',{attrs:{"box-height":'200px',"box-width":'30%',"excess-text":'+ {{count}}'},on:{"clickExcess":_vm.triggerClick}},_vm._l((_vm.images),function(imahe){return _c('img',{attrs:{"src":imahe.url}})})),_vm._v(" "),_c('photo-grid',{attrs:{"box-height":'200px',"box-width":'30%',"excess-text":'View {{count}} remaining images'},on:{"clickExcess":_vm.triggerClick}},_vm._l((_vm.images),function(imahe){return _c('img',{attrs:{"src":imahe.url}})}))],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","margin-bottom":"20px"}},[_c('h1',{staticStyle:{"display":"inline"}},[_vm._v("Vue.js Photo Grid")]),_vm._v(" "),_c('small',{staticStyle:{"display":"inline"}},[_vm._v(" by Lyor ❤")]),_c('br'),_c('br'),_vm._v(" "),_c('a',{staticClass:"github-button",staticStyle:{"margin-bottom":"20px"},attrs:{"href":"https://github.com/orlyyani/photo-grid","data-size":"large","data-show-count":"true","aria-label":"Star orlyyani/photo-grid on GitHub"}},[_vm._v("Star")]),_vm._v(" "),_c('p',[_vm._v("This component let you automatically arrange the photos depending on their clusters.")]),_vm._v(" "),_c('p',[_vm._v("It show how images are being displayed from single image until it would reach 4 and above.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ReadMore__ = __webpack_require__("qeuW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PhotoGrid__ = __webpack_require__("qGLL");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '',
    name: 'PhotoGrid',
    component: __WEBPACK_IMPORTED_MODULE_3__components_PhotoGrid__["a" /* default */],
    meta: { title: 'Photo Grid' }
  }, {
    path: '/read-more',
    name: 'ReadMore',
    component: __WEBPACK_IMPORTED_MODULE_2__components_ReadMore__["a" /* default */],
    meta: { title: 'Read More' }
  }]
}));

// Router.beforeEach((to, from, next) => {
//   document.title = to.meta.title(to)
//   next()
// })

/***/ }),

/***/ "a4LW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'read-more',
  data: function data() {
    return {
      msg: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
    };
  }
});

/***/ }),

/***/ "bW5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      image: [{
        title: "",
        url: "https://img00.deviantart.net/e895/i/2017/275/7/d/ultra_sun_ultra_moon_by_kawacy-dbpbuiq.jpg"
      }],
      images2: [{
        title: "",
        url: "https://img00.deviantart.net/e895/i/2017/275/7/d/ultra_sun_ultra_moon_by_kawacy-dbpbuiq.jpg"
      }, {
        title: "",
        url: "https://img00.deviantart.net/870d/i/2009/174/d/b/sweet_summer_ii_by_zanasoul.jpg"
      }],
      images3: [{
        title: "",
        url: "https://img00.deviantart.net/e895/i/2017/275/7/d/ultra_sun_ultra_moon_by_kawacy-dbpbuiq.jpg"
      }, {
        title: "",
        url: "https://img00.deviantart.net/870d/i/2009/174/d/b/sweet_summer_ii_by_zanasoul.jpg"
      }, {
        title: "",
        url: "https://pre00.deviantart.net/9b5b/th/pre/i/2017/205/c/8/electra_by_mistanphotography-dbhgxsz.jpg"
      }],
      images4: [{
        title: "",
        url: "https://img00.deviantart.net/e895/i/2017/275/7/d/ultra_sun_ultra_moon_by_kawacy-dbpbuiq.jpg"
      }, {
        title: "",
        url: "https://img00.deviantart.net/870d/i/2009/174/d/b/sweet_summer_ii_by_zanasoul.jpg"
      }, {
        title: "",
        url: "https://pre00.deviantart.net/9b5b/th/pre/i/2017/205/c/8/electra_by_mistanphotography-dbhgxsz.jpg"
      }, {
        title: "",
        url: "https://img00.deviantart.net/47b3/i/2017/140/0/7/wonder_woman_by_pencilhead7-db9w9lw.png"
      }],
      images: [{
        title: "",
        url: "https://img00.deviantart.net/e895/i/2017/275/7/d/ultra_sun_ultra_moon_by_kawacy-dbpbuiq.jpg"
      }, {
        title: "",
        url: "https://img00.deviantart.net/870d/i/2009/174/d/b/sweet_summer_ii_by_zanasoul.jpg"
      }, {
        title: "",
        url: "https://pre00.deviantart.net/9b5b/th/pre/i/2017/205/c/8/electra_by_mistanphotography-dbhgxsz.jpg"
      }, {
        title: "",
        url: "https://img00.deviantart.net/47b3/i/2017/140/0/7/wonder_woman_by_pencilhead7-db9w9lw.png"
      }, {
        title: "",
        url: "https://orig00.deviantart.net/2b7a/f/2017/275/5/6/daily_paint_1777__swineapple_by_cryptid_creations-dbpboas.png"
      }, {
        title: "",
        url: "https://pre00.deviantart.net/a41c/th/pre/i/2015/014/9/8/swan_by_avine-d8dw53d.jpg"
      }]
    };
  },


  methods: {
    triggerClick: function triggerClick() {
      // Some code here...
    }
  }
});

/***/ }),

/***/ "j4mo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"read-more"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('h1',[_vm._v("Vue.js Read More")]),_vm._v(" "),_c('p',[_vm._v("Read-More is a simple plugin that has been created with ❤ by a bored developer.")]),_vm._v(" "),_c('a',{staticClass:"github-button",staticStyle:{"margin-bottom":"20px"},attrs:{"href":"https://github.com/orlyyani/read-more","data-size":"large","data-show-count":"true","aria-label":"Star orlyyani/read-more on GitHub"}},[_vm._v("Star")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","margin":"0 auto","margin-top":"20px"}},[_c('h4',[_vm._v("With Read Less")]),_vm._v(" "),_c('read-more',{attrs:{"text":_vm.msg,"less-str":"read less","max-chars":200}}),_vm._v(" "),_c('h4',[_vm._v("Without Read Less")]),_vm._v(" "),_c('read-more',{attrs:{"text":_vm.msg,"max-chars":50}}),_vm._v(" "),_c('h4',[_vm._v("Redirect")]),_vm._v(" "),_c('read-more',{attrs:{"text":_vm.msg,"max-chars":150,"link":'https://github.com/orlyyani/read-more'}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "muSi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pk5n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qGLL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhotoGrid_vue__ = __webpack_require__("bW5e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4f518ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PhotoGrid_vue__ = __webpack_require__("Tnj0");
function injectStyle (ssrContext) {
  __webpack_require__("muSi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f4f518ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PhotoGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4f518ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PhotoGrid_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qeuW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReadMore_vue__ = __webpack_require__("a4LW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aa89f60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ReadMore_vue__ = __webpack_require__("j4mo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReadMore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aa89f60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ReadMore_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tYPr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w9Dy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PhotoGridComponent_vue__ = __webpack_require__("x+xE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PhotoGridComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PhotoGridComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_379b9a33_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_PhotoGridComponent_vue__ = __webpack_require__("MY3S");
function injectStyle (ssrContext) {
  __webpack_require__("CCSn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-379b9a33"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PhotoGridComponent_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_379b9a33_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_PhotoGridComponent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x+xE":
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//

module.exports = {
	props: {
		boxWidth: { type: String, default: 'auto' },
		boxHeight: { type: String, default: '200px' },
		boxBorder: { type: Number, default: 0 },
		excessText: { type: String, default: 'View more {{count}} images' }
	},

	data: function data() {
		return {
			styles: {
				width: this.boxWidth,
				height: this.boxHeight,
				'border-radius': this.boxBorder + 'px',
				overflow: 'hidden'
			},
			image_excess: 0
		};
	},

	computed: {
		$child: function $child() {
			return this.$el;
		},
		countImageLength: function countImageLength() {
			return this.$slots.default.length;
		},
		count: function count() {
			return this.$slots.default.length - 4;
		}
	},

	mounted: function mounted() {
		var __image_Size = this.$slots.default.length;
		this.$slots.default.forEach(function (vnode) {
			vnode.elm.className += "__image_body";

			vnode.elm.setAttribute("style", "background-image: url( " + vnode.elm.src + ")");
			switch (true) {
				case __image_Size == 1:
					vnode.elm.className += " __single";
					break;
				case __image_Size == 3:
					vnode.elm.className += " __triple";
					break;
				case __image_Size == 4:
					vnode.elm.className += " __quarter";
					break;
				case __image_Size > 4:
					vnode.elm.className += " __quarter __more_image";
					break;
			}
		}), this.pareseExcessText();
	},


	methods: {
		passData: function passData() {
			this.$emit('clickExcess');
		},
		pareseExcessText: function pareseExcessText() {
			this.image_excess = this.excessText.replace('{{count}}', this.$slots.default.length);
		}
	}
};

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.727e8d164505c62383ef.js